// Translation for ru
export const ru = {
        common: {
            save: 'Сохранить',
            cancel: 'Отмена',
            close: 'Закрыть',
            delete: 'Удалить',
            edit: 'Редактировать',
            activate: 'Активировать',
            add: 'Добавить',
            saving: 'Сохранение...',
            loading: 'Загрузка...',
            active: 'АКТИВНО',
            inUse: 'В использовании',
            test: 'Тест',
            searchApps: 'Поиск приложений...',
            betaBanner: 'BETA - Сервис пока недоступен!'
        },
        header: {
            creditBalance: 'Баланс',
            minutes: 'МИН'
        },
        auth: {
            signIn: 'Вход',
            signUp: 'Регистрация',
            username: 'Имя пользователя',
            password: 'Пароль',
            continue: 'Продолжить',
            noAccount: 'Нет аккаунта?',
            hasAccount: 'У вас уже есть аккаунт?',
            loginError: 'Ошибка входа',
            invalidCredentials: 'Неверное имя пользователя или пароль',
            rateLimited: 'Слишком много попыток входа. Пожалуйста, подождите.',
            sessionExpired: 'Ваша сессия истекла. Используйте новую волшебную ссылку.',
            magicLinkInvalid: 'Ссылка входа недействительна или истекла.',
            magicLinkSuccess: 'Добро пожаловать! Вы успешно вошли.',
            magicLinkProcessing: 'Обработка входа...',
            connectionError: 'Ошибка соединения. Пожалуйста, попробуйте снова.'
        },
        profile: {
            myProgress: 'Мой прогресс обучения',
            signOut: 'Выход',
            plan: 'План: '
        },
        settings: {
            title: 'Параметры',
            tabs: {
                uiSettings: 'Параметры UI',
                systemPrompt: 'Системный запрос',
                llmProfiles: 'Профили LLM',
                ttsProfiles: 'Профили TTS',
                language: 'Язык',
            },
            uiSettings: {
                title: 'Пользовательский интерфейс',
                themeMode: 'Режим темы',
                darkMode: 'Тёмный режим',
                lightMode: 'Светлый режим',
                themeColor: 'Цвет темы',
                themeColorDesc: 'Выберите цвет акцента для кнопок, иконок и выделений',
                background: 'Фон',
                backgroundDesc: 'Выберите фон для вашего рабочего пространства',
                selectBackgroundColor: 'Выберите цвет фона',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Фокус',
                    concentration: 'Концентрация',
                    relaxation: 'Расслабление',
                    lianas: 'Лианы',
                    color: 'Цвет'
                },
                backgroundColors: {
                    deepDark: 'Глубокий чёрный',
                    darkGrey: 'Тёмно-серый',
                    midnightBlue: 'Полуночный синий',
                    indigo: 'Индиго',
                    darkTeal: 'Тёмно-синий-зелёный',
                    brown: 'Коричневый',
                    darkRed: 'Тёмно-красный',
                    deepPurple: 'Глубокий фиолетовый',
                    pureWhite: 'Чистый белый',
                    softWhite: 'Мягкий белый',
                    lightGrey: 'Светло-серый',
                    paleBlue: 'Бледно-синий',
                    paleGreen: 'Бледно-зелёный',
                    paleOrange: 'Бледно-оранжевый',
                    lavender: 'Лаванда',
                    blueGrey: 'Сине-серый'
                }
            },
            systemPrompt: {
                label: 'Системный запрос:',
                placeholder: 'Загрузка системного запроса...',
                emptyError: 'Системный запрос не может быть пустым!',
                saveSuccess: '✓ Системный запрос успешно сохранён!',
                loadError: 'Ошибка при загрузке системного запроса',
                saveError: 'Ошибка при сохранении'
            },
            llmProfiles: {
                addButton: '+ Добавить новое подключение',
                newConnection: 'Новое подключение',
                editConnection: 'Редактировать подключение',
                emptyState: 'Нет доступных LLM подключений. Нажмите ниже для добавления.',
                loadingProfiles: 'Загрузка профилей...',
                nameLabel: 'Имя *',
                namePlaceholder: 'например OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API ключ *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Модель *',
                modelPlaceholder: 'gpt-4, mistral-tiny, и т.д.',
                allFieldsRequired: 'Все поля должны быть заполнены!',
                saveSuccess: '✓ Профиль успешно сохранён!',
                deleteConfirm: 'Вы уверены, что хотите удалить "{name}"?',
                profileNotFound: 'Профиль не найден!',
                loadError: 'Ошибка при загрузке профилей',
                saveError: 'Ошибка при сохранении',
                activateError: 'Ошибка при активации',
                deleteError: 'Ошибка при удалении',
                modelInfo: 'Модель: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Добавить новый голос',
                newVoice: 'Новый голос',
                editVoice: 'Редактировать голос',
                emptyState: 'Нет доступных TTS профилей. Нажмите ниже для добавления.',
                loadingProfiles: 'Загрузка TTS профилей...',
                nameLabel: 'Имя',
                namePlaceholder: 'например Мой ElevenLabs Adam',
                providerLabel: 'Поставщик',
                providerPlaceholder: 'например ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API ключ *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID модели *',
                modelIdPlaceholder: 'например eleven_monolingual_v1',
                voiceIdLabel: 'ID голоса',
                voiceIdPlaceholder: 'например pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Все поля должны быть заполнены!',
                saveSuccess: '✓ TTS профиль успешно сохранён!',
                deleteConfirm: 'Вы уверены, что хотите удалить "{name}"?',
                loadError: 'Ошибка при загрузке TTS профилей',
                saveError: 'Ошибка при сохранении',
                activateError: 'Ошибка при активации',
                deleteError: 'Ошибка при удалении'
            },
            language: {
                title: 'Выбрать язык',
                description: 'Выберите предпочитаемый язык для пользовательского интерфейса'
            },
        },
        chat: {
            ready: 'Готово',
            start: 'НАЧАТЬ',
            stop: 'ОСТАНОВИТЬ',
            initialMessage: 'Нажмите НАЧАТЬ для беседы в реальном времени.',
            listening: 'Слушаю...',
            speaking: 'Торстен говорит...',
            userLabel: 'Вы',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Напишите сообщение...',
            send: 'Отправить',
            loginRequired: 'Пожалуйста, войдите для использования этого сервиса.',
            loginButton: 'Войти сейчас',
            magicLinkRequired: 'Пожалуйста, используйте волшебную ссылку для входа.',
            creditLimitError: 'Ваша почасовая квота исчерпана. Обновите план (Medium/Premium) для продолжения.',
            serviceDisabled: 'Служба чата в настоящее время недоступна. Пожалуйста, повторите попытку позже.'
        },
        notifications: {
            error: 'Ошибка',
            success: 'Успех',
            info: 'Информация',
            unknownError: 'Произошла неизвестная ошибка'
        },
        cookie: {
            message: 'Этот веб-сайт использует файлы cookie для обеспечения наилучшего взаимодействия с пользователем.',
            accept: 'Принять'
        },
        curriculum: {
                buttonLabel: 'Учебная программа',
                buttonTitle: 'Показать содержание учебной программы',
                modalTitle: 'Учебная программа {app}',
                sections: {
                    topic: 'Тема учебной программы',
                    explanation: 'Объяснение для детей',
                    studentProfile: 'Профиль ученика'
                },
                topic: {
                    empty: 'В бэкенде к этому мини-приложению не привязана тема учебной программы.',
                    missingDetail: 'Подробные данные учебной программы для этого мини-приложения пока недоступны в бэкенде.',
                    learningGoals: 'Цели обучения',
                    prerequisites: 'Предварительные требования',
                    unitLabel: 'Раздел',
                    durationLabel: 'Длительность',
                    difficultyLabel: 'Сложность',
                    hours: 'ч',
                    minutes: 'мин'
                },
                explanation: {
                    empty: 'Объяснение для детей недоступно.',
                    loadingPrepare: 'ИИ готовит объяснение',
                    loadingExplain: 'ИИ объясняет тему детским языком',
                    requestFailed: 'Не удалось создать объяснение для детей.'
                },
                studentProfile: {
                    country: 'Страна',
                    region: 'Регион / Область',
                    schoolType: 'Тип школы',
                    grade: 'Класс',
                    noContext: 'Контекст ученика отсутствует.',
                    childProfileNotFound: 'В бэкенде не найден профиль ученика для текущего входа.',
                    loginProfileIncomplete: 'Профиль входа ещё не содержит полного контекста ученика.',
                    educationContextNotFound: 'Профиль ученика найден, но не назначена учебная программа.',
                    noToken: 'Авторизованный ученик не найден.'
                },
                errors: {
                    signInRequired: 'Пожалуйста, войдите, чтобы просмотреть учебную программу.',
                    appIdMissing: 'Отсутствует идентификатор приложения.',
                    loadFailed: 'Не удалось загрузить данные учебной программы.'
                }
            }
    };
